import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import {
  PaginationWrapper,
  PaginationCounter,
  ReportRowsPerPage,
  ReportPaginationControls,
} from '../../common/Pagination';
import { ANALYTICS_UPDATE_TABLE } from '../../../store/reducers/analytics';

export function ReportPagination({ reportType }) {
  const dispatch = useDispatch();
  const { totalCount, table } = useSelector((state) => state.analytics.reports[reportType]);
  const { page, rowsPerPage } = table;

  const showPagination = totalCount > rowsPerPage;

  return (
    <PaginationWrapper reportTable>
      <PaginationCounter rowsPerPage={rowsPerPage} totalCount={totalCount} page={page} />

      {showPagination && (
        <ReportPaginationControls
          currentPage={page}
          pageCount={Math.ceil(totalCount / rowsPerPage)}
          onPageChange={({ selected }) =>
            dispatch({ type: ANALYTICS_UPDATE_TABLE, payload: { reportType, page: selected } })
          }
        />
      )}

      <ReportRowsPerPage
        options={[10, 20, 50, 100]}
        current={rowsPerPage}
        onChange={(rowsPerPage) =>
          dispatch({
            type: ANALYTICS_UPDATE_TABLE,
            payload: { reportType, rowsPerPage, page: 0 },
          })
        }
      />
    </PaginationWrapper>
  );
}

ReportPagination.propTypes = {
  reportType: PropTypes.string.isRequired,
};
